import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconCloseSmall extends Component<SVGIconSearchProps> {
  render() {
    const { width = 30, height = 30, color = '#FFF', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 17 15`}
        fill={color}
        {...rest}
      >
        <g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 5.93021L12.719 0.210211C12.865 0.0642108 13.058 -0.00878906 13.25 -0.00878906C13.654 -0.00878906 14 0.315211 14 0.740211C14 0.933211 13.927 1.12521 13.781 1.27221L8.061 6.99121L13.78 12.7102C13.927 12.8572 14 13.0492 14 13.2412C14 13.6682 13.651 13.9912 13.25 13.9912C13.058 13.9912 12.865 13.9182 12.719 13.7722L7 8.05321L1.281 13.7722C1.135 13.9182 0.942 13.9912 0.75 13.9912C0.349 13.9912 0 13.6682 0 13.2412C0 13.0492 0.0729998 12.8572 0.22 12.7102L5.939 6.99121L0.219 1.27221C0.0729999 1.12521 0 0.933211 0 0.740211C0 0.315211 0.346 -0.00878906 0.75 -0.00878906C0.942 -0.00878906 1.135 0.0642108 1.281 0.210211L7 5.93021Z"
            fill={color}
          />
        </g>
      </SVG>
    );
  }
}
